/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreditCardManualPayment/view.blocks to change it.
import EffectiveDateSelect from './EffectiveDateSelect/index'
import React from 'react'
import TransactionIdInput from './TransactionIdInput/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CreditCardManualPayment({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/PaymentMethods/CreditCardManualPayment"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="CreditCardManualPayment.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TransactionIdInput
  viewPath={`${viewPath}/TransactionIdInput`}
/>
<EffectiveDateSelect
  viewPath={`${viewPath}/EffectiveDateSelect`}
/>
</div>
{children}
</React.Fragment>)
}